import React from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';

import { CohesionProvider } from '../analytics/cohesion';
import {
  CurrentPageProvider,
  LandingPageGuard,
  PageTracker,
  ProtectedPage,
  ProviderCheckoutEligibilityGuard,
  ROUTES,
} from '../routing';
import { TealiumProvider } from '../tagging/tealium/TealiumProvider';
import AddProvidersToRosterPage from './AddProvidersToRosterPage/AddProvidersToRosterPage';
import { AuthProvider } from './Auth';
import CheckoutPage from './CheckoutPage/CheckoutPage';
import ErrorComponent from './Error/Error';
import FeatureFlagsProvider from './FeatureFlag/FeatureFlagsProvider';
import Footer from './Footer/Footer';
import Header from './Header/Header';
import TermsOfService from './TermsOfService/TermsOfService';

const PageLayout = () => {
  return (
    <AuthProvider>
      <Header />
      <div className="App">
        <Outlet />
      </div>
      <Footer />
    </AuthProvider>
  );
};

const AppRouter = () => (
  <Routes>
    <Route element={<PageLayout />}>
      <Route path={ROUTES.LANDING_PAGE.path} element={<LandingPageGuard />} />

      <Route
        path={ROUTES.ADD_PROVIDERS_TO_ROSTER_PAGE.path}
        element={
          <ProtectedPage
            allowedCategories={ROUTES.ADD_PROVIDERS_TO_ROSTER_PAGE.auth}
          >
            <PageTracker
              tracking={ROUTES.ADD_PROVIDERS_TO_ROSTER_PAGE.tracking}
            >
              <AddProvidersToRosterPage />
            </PageTracker>
          </ProtectedPage>
        }
      />

      <Route
        path={ROUTES.CHECKOUT_PAGE.path}
        element={
          <ProtectedPage allowedCategories={ROUTES.CHECKOUT_PAGE.auth}>
            <ProviderCheckoutEligibilityGuard>
              <PageTracker tracking={ROUTES.CHECKOUT_PAGE.tracking}>
                <CheckoutPage />
              </PageTracker>
            </ProviderCheckoutEligibilityGuard>
          </ProtectedPage>
        }
      />

      <Route
        path={ROUTES.TERMS_PAGE.path}
        element={
          <PageTracker tracking={ROUTES.TERMS_PAGE.tracking}>
            <TermsOfService />
          </PageTracker>
        }
      />

      <Route
        path={ROUTES.ERROR_PAGE.path}
        element={
          <PageTracker tracking={ROUTES.ERROR_PAGE.tracking}>
            <ErrorComponent />
          </PageTracker>
        }
      />
    </Route>
  </Routes>
);

const App = () => (
  <FeatureFlagsProvider>
    <TealiumProvider>
      <CohesionProvider>
        <CurrentPageProvider>
          <AppRouter />
        </CurrentPageProvider>
      </CohesionProvider>
    </TealiumProvider>
  </FeatureFlagsProvider>
);

export default App;
